import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '@store';
import {ITest} from '@types';
import {testsAPI} from '@api/methods';
import {IDLE, PENDING} from '@constants/loadingState';

interface TestsState {
  loading: string;
  addTestLoading: string;
  deleteTestLoading: string;
  tests: ITest[];
}

const initialState: TestsState = {
  loading: IDLE,
  addTestLoading: IDLE,
  deleteTestLoading: IDLE,
  tests: [
    /*{
      id: 1,
      name: 'Unit',
      integrationCount: 1,
      autoCoverage: 21.23,
      manualCoverage: 10.0,
      lastActivity: '13:45, сегодня, 26 Апреля, 2025',
    },
    {
      id: 2,
      name: 'Component',
      integrationCount: 23,
      autoCoverage: 4.23,
      lastActivity: '13:45, сегодня, 26 Апреля, 2025',
    },
    {
      id: 3,
      name: 'API',
      integrationCount: 235,
      lastActivity: '13:45, сегодня, 26 Апреля, 2025',
    },*/
  ],
};

export const getTests = createAsyncThunk<ITest[], any, {state: RootState}>(
  'tests/get/all',
  async () => {
    return await testsAPI.getTests();
  },
);

export const getTestsFull = createAsyncThunk<ITest[], any, {state: RootState}>(
  'tests/get/all/full',
  async () => {
    return await testsAPI.getTestsFull();
  },
);

export const addTest = createAsyncThunk<
  {name: string; id: number},
  any,
  {state: RootState}
>('test/add/new', async ({name}: {name: string}) => {
  return await testsAPI.addTest(name);
});

export const editTest = createAsyncThunk<
  {name: string; id: number},
  {name: string; id: number},
  {state: RootState}
>('test/edit', async ({name, id}) => {
  return await testsAPI.editTest(name, id);
});

export const deleteTests = createAsyncThunk<string, number[], {state: RootState}>(
  'test/delete',
  async test_type_ids => {
    return await testsAPI.deleteTests(test_type_ids);
  },
);

const testsSlice = createSlice({
  name: 'tests',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getTests.pending, state => {
      state.loading = PENDING;
    });
    builder.addCase(getTests.rejected, state => {
      state.loading = IDLE;
    });
    builder.addCase(getTests.fulfilled, (state, {payload}) => {
      state.loading = IDLE;
      state.tests = payload;
    });
    builder.addCase(getTestsFull.pending, state => {
      state.loading = PENDING;
    });
    builder.addCase(getTestsFull.rejected, state => {
      state.loading = IDLE;
    });
    builder.addCase(getTestsFull.fulfilled, (state, {payload}) => {
      state.loading = IDLE;
      state.tests = payload;
    });
    builder.addCase(addTest.pending, state => {
      state.addTestLoading = PENDING;
    });
    builder.addCase(addTest.rejected, state => {
      state.addTestLoading = IDLE;
    });
    builder.addCase(addTest.fulfilled, state => {
      state.addTestLoading = IDLE;
    });
    builder.addCase(editTest.pending, state => {
      state.addTestLoading = PENDING;
    });
    builder.addCase(editTest.rejected, state => {
      state.addTestLoading = IDLE;
    });
    builder.addCase(editTest.fulfilled, state => {
      state.addTestLoading = IDLE;
    });
    builder.addCase(deleteTests.pending, state => {
      state.deleteTestLoading = PENDING;
    });
    builder.addCase(deleteTests.rejected, state => {
      state.deleteTestLoading = IDLE;
    });
    builder.addCase(deleteTests.fulfilled, state => {
      state.deleteTestLoading = IDLE;
    });
  },
});

export const tests = (state: RootState) => state.tests.tests;

// eslint-disable-next-line no-empty-pattern
export const {} = testsSlice.actions;
export default testsSlice.reducer;
